import "./VideoItem.css";
import React from "react";

const VideoItem = ({ video, onVideoSelected }) => {
  // these both are same things
  // const video = props.video;
  // const { video } = props;

  return (
    <div className="video-item item" onClick={() => onVideoSelected(video)}>
      <img
        className="ui image"
        src={video.snippet.thumbnails.medium.url}
        alt={video.snippet.title}
      />
      <div className="content">
        <div className="header">{video.snippet.title}</div>
        <div className="description">{video.snippet.publishTime}</div>
      </div>
    </div>
  );
};

export default VideoItem;
